class CartQuantity extends HTMLElement{
  constructor(){
    super();
    this.plusButton = this.querySelector('[data-item-plus]');
    this.minusButton = this.querySelector('[data-item-minus]');
    this.indicateProcessing = this.getAttribute('data-processing')? true:false;

    this.quantityInput = this.querySelector('input');
    this.debounceChange = debounce((event)=>{
      this.onInputchange(event)
    },250);
    this.quantityInput.addEventListener('change',this.debounceChange.bind(this));
    this.maxValue = parseInt(this.quantityInput.getAttribute('max'));
    this.minValue = parseInt(this.quantityInput.getAttribute('min'));
    
    this.plusButton?.addEventListener('click',this.quantityUp.bind(this))
    this.minusButton?.addEventListener('click',this.quantityDown.bind(this));
  
  }
  quantityUp(event){
    if(this.indicateProcessing){
      let inputValue =  parseInt(this.quantityInput.value);
      this.setAttribute('data-processing','true');  
      if(this.validateQuantity(inputValue,inputValue+1)){
        this.quantityInput.value = inputValue + 1;
        let cart = document.querySelector('shopping-cart');
        cart.quantityUpdate(this.quantityInput.getAttribute('key'),this.quantityInput.value)
      }
    }
  }

  onInputchange(event){
    if(!this.validateQuantity(null,event.target.value)){
      alert(`Please Enter Quantity Between ${this.minValue} and ${this.maxValue}`);
    }
  }
  
  quantityDown(event){
    if(this.indicateProcessing){
      let inputValue =  parseInt(this.quantityInput.value);
      this.setAttribute('data-processing','true');
      if(this.validateQuantity(inputValue,inputValue - 1)){
        this.quantityInput.value = inputValue - 1;
        let cart = document.querySelector('shopping-cart');
        cart.quantityUpdate(this.quantityInput.getAttribute('key'),this.quantityInput.value)
      }
    }
    
  }
   validateQuantity(previousvalue,currentvalue){
     if(this.maxValue){
       if(currentvalue > this.maxValue){
         return false;
       }
     }
    if(this.minValue){
       if(currentvalue < this.minValue){
         return false;
       }
     }
     return true
  }
}
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
customElements.define('cart-quantity',CartQuantity);


class ShoppingCart extends HTMLElement{
  constructor(){
    super();
    this.container = this;
    this.container.addEventListener('click',function(event){
      if(event.target.classList.contains('cart-drawer')){
        this.closeShippingCart();
      }
    });
    document.addEventListener("DOMContentLoaded", (event) => {
     this.getCartJson()
    });
    this.initEvents();
  }
  initEvents(){
    this.container.querySelector('.close-drawer').addEventListener('click',function(event){
       this.closeShippingCart();
    }.bind(this))
  }

  updateCartDrawer(){

      fetch(`/cart?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('shopping-cart');
          document.querySelector('shopping-cart').innerHTML = sourceQty.innerHTML;
          this.initEvents()
        })
        .catch((e) => {
          console.error(e);
        });
  }
  updateCartcontentOutside(){
    fetch(`/cart?section_id=header`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('.basket_count_box') ||html.querySelector('.cart_count_box') ;
          if(sourceQty && document.querySelector('.basket_count_box')){
            document.querySelector('.basket_count_box').innerHTML = sourceQty.innerHTML;  
          }
          if(sourceQty && document.querySelector('.cart_count_box')){
            
            document.querySelector('.cart_count_box').innerHTML = sourceQty.innerHTML;  
            document.querySelector('.cart_count_box').classList.remove('hide')
          }
         
        })
        .catch((e) => {
          console.error(e);
        })
  }
  getCartJson(){
    fetch('/cart.js').then((data)=>{
      return data.json();
    })
    .then((json)=>{
      this.cartJsonData = json
    })
     
  }
  quantityUpdate(line,quantity){
    const body = JSON.stringify({
      line,
      quantity,
      sections: Array.from(this.getSectionToupdate().map((section)=>(section.id))).toString(),
      sections_url: window.location.pathname,
    });
    
    fetch(`${window.cart.change_url}.js`,{
      method: 'POST',
      headers: { 'Content-Type': 'application/json'},
      body
    }).then((response) =>{
      return response.json();
    }).
      then((content)=>{
          this.cartJsonData = content
        if(content.status == 422) {
          let ErrorElement = document.getElementById(`Line-item-error-${line}`);
          if(!ErrorElement) return;
          ErrorElement.classList.remove('hide');
          ErrorElement.querySelector('.cart-item__error-text').innerHTML = content.message;
          return;
        };
        
        let ErrorElement = document.getElementById(`Line-item-error-${line}`);
        if(ErrorElement) {
          ErrorElement.classList.add('hide');
        }
        let sections = content.sections;
        this.getSectionToupdate().forEach((section)=>{
          let element = document.createElement('p');
          if(sections[section.id]){
          element.innerHTML = sections[section.id];
          section.selectors.forEach((toUpdateElement)=>{
            
            let toSelectElement =  this.container.querySelector(toUpdateElement) || document.querySelector(toUpdateElement) || document.querySelector('shopify-section-cart-'+sections[section.id]);
            if(toSelectElement){
              toSelectElement.innerHTML = element.querySelector(toUpdateElement).innerHTML;  
            }
          });
        }
        });
        let lineElement = document.createElement('p');
        
         lineElement.innerHTML =  content.sections['cart-drawer'];
        let outputData = lineElement.querySelector(`#cart-item-${line}`).querySelector('.cart-item-info').innerHTML
      
        document.getElementById(`cart-item-${line}`).querySelector('.cart-item-info').innerHTML = outputData;
        this.updateByJson()
      }).catch((error)=>{
        console.error(error)
        console.log(error)
      });
    
  }
  
  removeItem(line){
    let data = {
      'line':line,
      'quantity':0
    }
    fetch(`${window.cart.change_url}.js`,{
    method: "POST", 
    headers: {
      "Content-Type": "application/json",
      Accept: `application/json`
    },
    body: JSON.stringify(data)
    })
    .then((data) =>{
      this.updateCartDrawer();
      this.updateCartcontentOutside()
    })
  }
  updateByJson(){
    let cartData = this.cartJsonData;
    // by using cart javascript Object update element outside component 

    
    
  }
  getSectionToupdate(){
    return [
      {
        id:'cart-drawer',
        selectors:['#shopping-cart-footer','#cart-count','.shipping-info']
      },
      {
        id:'header',
        selectors:['.cart_count']
      }
    ]
  }
  openShippingCart(){
    document.body.style.overflow ="hidden";
    this.classList.add('open')
  }
  closeShippingCart(){
    document.body.style.overflow ="inherit";
    this.classList.remove('open');
  }
  
}

customElements.define('shopping-cart',ShoppingCart);
class RemoveItem extends HTMLElement{
  constructor(){
    super();
    this.line = parseInt(this.getAttribute('data-line'));
    this.item = this;
    this.item.addEventListener('click',this.removeItem.bind(this))
  }
  removeItem(){
    let cart = document.querySelector('shopping-cart');
    if(cart){
      cart.removeItem(this.line)
    }
  }
}

customElements.define('remove-item',RemoveItem)

class SearchPredictive extends HTMLElement{
  constructor(){
    super();
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('.search-results');
      this.resourseTypes = this.getAttribute('data-resources-type');
      this.collectionSearch = this.querySelector('[data-collection-search]');
      this.pageSearch = this.querySelector('[data-page-search]');
      this.productSearch = this.querySelector('[data-product-search]');
      this.articleSearch = this.querySelector('[data-article-search]');
    
      this.inputSearchEvents();

  }

  inputSearchEvents(){
      this.debounceSearchPerformed = debounce((event)=>{
       this.performSearch(event);
      },250);
      this.input.addEventListener('keydown',this.debounceSearchPerformed.bind(this))
  }
  
  performSearch(){
    let searchKey = this.input.value;
    
    if(searchKey == ''){
        this.querySelector('[data-collection-search]').classList.add('hide')
        this.querySelector('[data-page-search]').classList.add('hide')
        this.querySelector('[data-product-search]').querySelector('.product-list').classList.add('hide')
        this.querySelector('[data-article-search]').classList.add('hide');
        this.querySelector('[data-trending-products]').classList.remove('hide');
        // this.querySelector('[data-product-search]').innerHTML = `<p>No Product for your suggestion</p>`
      return;
    }
    fetch(`/search/suggest?q=${searchKey}&resources[type]=${this.resourseTypes}&section_id=predictive-search`)
      .then((data)=>{
        if(data.status == "422") {
           this.querySelector('[data-trending-products]').classList.remove('hide');
           console.log("no Product found")
           return;
         }
      return  data.text()
      })
      .then((data)=>{
         
        let newElement = document.createElement('p');
        newElement.innerHTML = data;
        if(searchKey != ''){
          this.querySelector('.search-results').innerHTML = newElement.querySelector('.search-results')?.innerHTML;  
          this.querySelector('[data-trending-products]').querySelector('.product-list').classList.remove('hide');
        }
        else{
          this.pageSearch.classList.add('hide')
          this.collectionSearch.classList.add('hide')
          this.articleSearch.classList.add('hide');
        }
        
      })
    .catch((error)=>{
      console.log(error);
    })
  }
}
customElements.define('search-predictive',SearchPredictive);
document.addEventListener("DOMContentLoaded", (event) => {
  let searchModalOverlay = document.querySelector('.search-modal .modal-overlay');
  if(searchModalOverlay){
    searchModalOverlay.addEventListener('click',function(event){
      let searchCloseBtn = document.querySelector('.search-modal .icon-close-wrapper');
      if(searchCloseBtn){
        searchCloseBtn.dispatchEvent(new Event('click'));  
      }
    });
  }
});
